import styles from './LPHeader.module.scss'
import { useEffect } from 'react'

const LPHeader: React.FunctionComponent = () => {
  useEffect(() => {
    const html = document.querySelector("html")
    const hamburger = document.querySelector(`.${styles.hamburger}`)
    const spMenu = document.querySelector(`.${styles.spMenu}`)

    if (!hamburger || !spMenu) return

    const handleClick = () => {
      const isOpen = hamburger.classList.contains(styles.open)

      if (isOpen) {
        hamburger.classList.remove(styles.open)
        spMenu.classList.remove(styles.show)
        if (html) {
          html.style.height = "auto"
          html.style.overflow = "initial"
        }
      } else {
        hamburger.classList.add(styles.open)
        spMenu.classList.add(styles.show)
        if (html) {
          html.style.height = "100vh"
          html.style.overflow = "hidden"
        }
      }
    }

    hamburger.addEventListener("click", handleClick)
    return () => {
      hamburger.removeEventListener("click", handleClick)
    }
  }, [])

  return (
    <>
      <header className={styles.header}>
        <div className={styles.headerWrapper}>
          <a href="/services/flamingo/">
            <img src="/img/LP/flamingo/flamingo_logo_new-1.png" alt="flamingoロゴ" />
          </a>
          <div className={styles.linkWrapper}>
            <a href="/services/flamingo/functions/" className={styles.textLink}>機能について</a>
            <a href="https://www.i3design.jp/contact" className={`${styles.button} ${styles.blackButton}`}>
              <span>お問い合わせ</span>
            </a>
          </div>
          <div className={styles.hamburger}>
            <span className={styles.topLine}></span>
            <span className={styles.middleLine}></span>
            <span className={styles.bottomLine}></span>
          </div>
        </div>
      </header>

      <div className={styles.spMenu}>
        <div className={styles.list}>
          <ul>
            <li className={styles.title}>プロダクト</li>
            <li className={styles.link}><a href="/services/flamingo/functions/">機能</a></li>
          </ul>
          <ul>
            <li className={styles.title}>サービス</li>
            <li className={styles.link}>
              <a href="https://www.i3design.jp/services/uiuxdesign" target="_blank">
                UI/UXデザイン
                <img className={styles.inNew} src="/img/LP/flamingo/open-in-new-black.png" alt="別タブ表示" />
              </a>
            </li>
            <li className={styles.link}>
              <a href="https://www.i3design.jp/services/frontend" target="_blank">
                フロントエンド開発
                <img className={styles.inNew} src="/img/LP/flamingo/open-in-new-black.png" alt="別タブ表示" />
              </a>
            </li>
            <li className={styles.link}>
              <a href="https://www.i3design.jp/services/growthhack" target="_blank">
                サイト改善ソリューション
                <img className={styles.inNew} src="/img/LP/flamingo/open-in-new-black.png" alt="別タブ表示" />
              </a>
            </li>
          </ul>
          <ul>
            <li className={styles.title}>運営会社</li>
            <li className={styles.link}>
              <a href="https://www.i3design.jp" target="_blank">
                <img className={styles.i3dLogo} src="/img/LP/flamingo/i3_logo.png" alt="i3ロゴ" />
                <img className={styles.inNew} src="/img/LP/flamingo/open-in-new-black.png" alt="別タブ表示" />
              </a>
            </li>
          </ul>
        </div>

        <div className={styles.contactWrapper}>
          <p className={styles.miniTitle}>
            <span className={`${styles.redBorder} ${styles.titleSide}`}></span>Contact
          </p>
          <h4>ご相談はお気軽に<br className={styles.spBr} />お問い合わせください</h4>
          <a href="https://www.i3design.jp/contact" target="_blank" className={`${styles.button} ${styles.blackButton}`}>
            お問い合わせ
          </a>
        </div>
      </div>
    </>
  )
}

export default LPHeader